<template>
  <v-card class="mt-4">
    <v-card-title class="third white--text font-weight-bold">
      <span class="ml-2">Informations du cheval</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row no-gutters>
          <v-col cols="12">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Nom du cheval</v-list-item-subtitle>
                <v-list-item-title>{{ horse.horse_name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>

        <v-divider />

        <v-row no-gutters>
          <v-col cols="12">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Race du cheval</v-list-item-subtitle>
                <v-list-item-title>{{ horse.horse_race }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>

        <v-divider />

        <v-row no-gutters>
          <v-col cols="12">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Numbre d'heures max/semaine</v-list-item-subtitle>
                <v-list-item-title>{{ horseEffort.weeklyEffort }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>

        <v-divider />

        <v-row no-gutters>
          <v-col cols="12">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Numbre d'heures max/mois</v-list-item-subtitle>
                <v-list-item-title v-if="!loading">{{ horseEffort.monthlyEffort }}</v-list-item-title>
                <v-list-item-title v-else>
                  <Loader :size="30" :width="3" />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>

        <v-divider />
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { computed, ref, onBeforeMount } from '@vue/composition-api';
import { startOfMonth, format, endOfMonth } from 'date-fns';
import store from '@/store';
import { minutesToHours } from '@/helpers/utils';
import { contentTypeSessions } from '@/helpers/amplify';
import { computeEffort } from '@/helpers/dataManager';

import Loader from '@/components/common/Loader.vue';

export default {
  components: { Loader },
  props: {
    horse: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  setup (props) {
    const monthlySessions = ref([]);
    const selectedDate = computed(() => store.getters.selectedDate);
    const loading = ref(false);

    const horseEffort = computed(() => {
      const horseWeeklySessions = store.getters.weeklySessionsByContentType(props.horse);
      return {
        monthlyEffort: minutesToHours(computeEffort(monthlySessions.value, props.horse)),
        weeklyEffort: minutesToHours(computeEffort(horseWeeklySessions, props.horse))
      };
    });

    onBeforeMount(async () => {
      const start = +format(startOfMonth(new Date(selectedDate.value)), 't');
      const end = +format(endOfMonth(new Date(selectedDate.value)), 't');
      loading.value = true;
      monthlySessions.value = await contentTypeSessions(props.horse, start, end);
      loading.value = false;
    });

    return { horseEffort, loading };
  }
};
</script>
